import { useMemo } from 'react';
import _ from 'lodash';
import {
  FISCAL_CALENDAR_START_DATE,
  FISCAL_CALENDAR_YEAR_TYPE,
  VIZ_OPTION_IDS,
} from '../Constants';
import { IFiscalCalendarInfo } from '../../datasets';
import { IDehydratedVizOption, IViz } from '../../discovery';
import { useOpenVizSelector } from '../redux/selectors/viz-selector.hook';

export const useFiscalCalendarInfo = ({ discoveryId }) => {
  const viz: IViz = useOpenVizSelector({ discoveryId });
  const { annotations, options } = useMemo(() => {
    const annotations = viz?.dataset?.annotations ?? [];
    const options = viz?.options ?? {};
    return { annotations, options };
  }, [viz]);
  return useMemo(() => {
    const { value: fiscalCalendarYearType } =
      _.find(annotations, { key: FISCAL_CALENDAR_YEAR_TYPE }) ?? {};
    const { value: fiscalCalendarStartDate } =
      _.find(annotations, { key: FISCAL_CALENDAR_START_DATE }) ?? {};
    const useFiscalCalendar =
      (fiscalCalendarYearType &&
        fiscalCalendarStartDate &&
        _.some(options as IDehydratedVizOption[], {
          key: VIZ_OPTION_IDS.useFiscalCalendar,
          value: 'true',
        })) ||
      _.get(options, VIZ_OPTION_IDS.useFiscalCalendar) === 'true';
    return {
      useFiscalCalendar,
      fiscalCalendarYearType,
      fiscalCalendarStartDate,
    } as IFiscalCalendarInfo;
  }, [annotations, options]);
};
